export const BROWSER_ERROR_LOG_PATH = '/browser-error-logger';
export const BROWSER_INFO_LOG_PATH = '/browser-info-logger';
export const BINARY_SUB = '[BINARY DATA]';
export var SeverityIndex;
(function (SeverityIndex) {
    // Emergency: system is unusable
    SeverityIndex[SeverityIndex["Emerg"] = 0] = "Emerg";
    SeverityIndex[SeverityIndex["Emergency"] = 0] = "Emergency";
    // Alert: action must be taken immediately
    SeverityIndex[SeverityIndex["Alert"] = 1] = "Alert";
    // Critical: critical conditions
    SeverityIndex[SeverityIndex["Crit"] = 2] = "Crit";
    SeverityIndex[SeverityIndex["Critical"] = 2] = "Critical";
    // Error: error conditions
    SeverityIndex[SeverityIndex["Err"] = 3] = "Err";
    SeverityIndex[SeverityIndex["Error"] = 3] = "Error";
    // Warning: warning conditions
    SeverityIndex[SeverityIndex["Warn"] = 4] = "Warn";
    SeverityIndex[SeverityIndex["Warning"] = 4] = "Warning";
    // Notice: normal but significant condition
    SeverityIndex[SeverityIndex["Notice"] = 5] = "Notice";
    // Informational: informational messages
    SeverityIndex[SeverityIndex["Info"] = 6] = "Info";
    SeverityIndex[SeverityIndex["Information"] = 6] = "Information";
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    SeverityIndex[SeverityIndex["Informational"] = 6] = "Informational";
    // Debug: debug-level messages
    SeverityIndex[SeverityIndex["Debug"] = 7] = "Debug";
})(SeverityIndex || (SeverityIndex = {}));
export var FacilityIndex;
(function (FacilityIndex) {
    FacilityIndex[FacilityIndex["Kern"] = 0] = "Kern";
    FacilityIndex[FacilityIndex["User"] = 1] = "User";
    FacilityIndex[FacilityIndex["Mail"] = 2] = "Mail";
    FacilityIndex[FacilityIndex["Daemon"] = 3] = "Daemon";
    FacilityIndex[FacilityIndex["Auth"] = 4] = "Auth";
    FacilityIndex[FacilityIndex["Syslog"] = 5] = "Syslog";
    FacilityIndex[FacilityIndex["Lpr"] = 6] = "Lpr";
    FacilityIndex[FacilityIndex["News"] = 7] = "News";
    FacilityIndex[FacilityIndex["Uucp"] = 8] = "Uucp";
    FacilityIndex[FacilityIndex["Clock"] = 9] = "Clock";
    FacilityIndex[FacilityIndex["Sec"] = 10] = "Sec";
    FacilityIndex[FacilityIndex["Ftp"] = 11] = "Ftp";
    FacilityIndex[FacilityIndex["Ntp"] = 12] = "Ntp";
    FacilityIndex[FacilityIndex["Audit"] = 13] = "Audit";
    FacilityIndex[FacilityIndex["Alert"] = 14] = "Alert";
    FacilityIndex[FacilityIndex["Local0"] = 16] = "Local0";
    FacilityIndex[FacilityIndex["Local1"] = 17] = "Local1";
    FacilityIndex[FacilityIndex["Local2"] = 18] = "Local2";
    FacilityIndex[FacilityIndex["Local3"] = 19] = "Local3";
    FacilityIndex[FacilityIndex["Local4"] = 20] = "Local4";
    FacilityIndex[FacilityIndex["Local5"] = 21] = "Local5";
    FacilityIndex[FacilityIndex["Local6"] = 22] = "Local6";
    FacilityIndex[FacilityIndex["Local7"] = 23] = "Local7";
})(FacilityIndex || (FacilityIndex = {}));
